import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { GoogleAnalyticsService } from '@sc-ui';
import { TracingService } from 'src/services/tracing.service';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

declare var Calendly: any;

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  styleUrls: ['./cta.component.scss']
})
export class CtaComponent implements AfterViewInit, OnDestroy {

  @Input()
  ctaUrl = '/stellencheck';

  @ViewChild('calendlyContainer')
  calendlyContainer: ElementRef;

  @ViewChild("scrollCta", { static: true })
  scrollCta: ElementRef;

  constructor(private ga: GoogleAnalyticsService, public tracingService: TracingService) { }

  goToBooking() {
    this.ga.track('bookingclick');
    window.open(this.tracingService.getDemoLink(), '_blank').focus();
  }

  ngAfterViewInit() {
    
    setTimeout(() => this.createAnimation(), 0);
    
  }

  createAnimation()
  {
    var el =  this.scrollCta.nativeElement;
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.create({
      trigger: el,
      id: "bg-anim",
      start: "center bottom",        
      end: "bottom top",
      // anticipatePin: 1,
      // markers: true,
      onEnter: () => document.body.classList.add('bg-primary-lightest'),
      onLeave: () => document.body.classList.remove('bg-primary-lightest'),
      onEnterBack: () => document.body.classList.add('bg-primary-lightest'),
      onLeaveBack: () => document.body.classList.remove('bg-primary-lightest'),
      toggleActions: "play reverse resume reset",
    });
  }

  ngOnDestroy(): void {

    document.body.classList.remove('bg-primary-lightest');

    let triggers = ScrollTrigger.getAll();
    triggers.forEach(trigger => {
      trigger.kill(true);
    });

    ScrollTrigger.refresh();


  }

}
